import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import FormTitle from '@src/mobile/layout/Component/FormTitle';
import FormSmallTitle from '@src/mobile/layout/Component/FormSmallTitle';
import FormInput from '@src/mobile/layout/Component/FormInput';
import UploadVideo from './UploadVideo';
import UploadPic from './UploadPic';

const Media = ({ formData, setFormDataHandle, warningTextList, updateId, updateSuccess }) => {
    
    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };
    
    return (
        <div className={styles.media}>
            <FormTitle name="img" title="形象照片" warningText={warningTextList['img']} isRequired={true} />
            <div className={styles.picInfo}>请上传面貌清晰的证件照一张，图片仅支持jpeg、png、gif、jpg 格式 </div>
            <div className={styles.picList}>
                <UploadPic name="img1" num={1} txt="点击上传半身照" formData={formData} changeInputHandle={changeInputHandle} updateId={updateId} updateSuccess={updateSuccess} />
            </div>
            <FormTitle name="info1" title="视频发布文案" warningText={warningTextList['info1']} isRequired={true} />
            <FormInput name="info1" formData={formData} changeInputHandle={changeInputHandle} />
            {/* <FormTitle name="videoLink" title="视频发布链接" warningText={warningTextList['videoLink']} isRequired={true} />
            <FormInput name="videoLink" formData={formData} changeInputHandle={changeInputHandle} /> */}
            <FormTitle name="video_self" title="视频作品" warningText={warningTextList['video_self']} isRequired={true} />
            <div className={styles.picInfo}>
                <p className={styles.t1} >根据所抽取赛道方向，拍摄60-90s的主题短视频。</p>
                <p>视频内容要求：不使用美颜、不使用滤镜，视频为竖屏比例为9：16，分辨率1080x1920PX，视频仅支持mp4、mov、quicktime 格式。不得出现海尔以外其他品牌。 </p>
                <p>单个视频文件大小不能超过500M。 </p>
                <p>此外，在提供完整版视频之外，还需提交一版无任何特效、花字、音乐、字幕等后期制作的净版视频。</p>
            </div>
            <UploadVideo name="video_self" formData={formData} title="上传完整版视频" changeInputHandle={changeInputHandle} />
            <UploadVideo name="video_production" formData={formData} title="上传净版视频" changeInputHandle={changeInputHandle} />
        </div>
    );
};

Media.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateId: PropTypes.string,
    updateSuccess: PropTypes.bool
};

export default errorBoundary(Media);
